<div class="echr-page-footer">
    <p>
        Connected to {{api}}
        <br />
        Version : {{version}}
    </p>
</div>
